import { createContext } from 'react';
export { default } from './root';

export const RootContext = createContext(null);
